import { createContext } from 'react';

export const leftButtonVisibleContext = createContext<boolean>(false);
